module.exports = __webpack_public_path__ + "static/media/windows4.e6f15f90.png";